import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs';
import { EdiDespatchAdvice, GungEdimessageType } from '../../models/edi';
import { EdiMessageBaseActionConfigService } from '../edi-message-base-action-config/edi-message-base-action-config.service';
import { ActionButtonConfigService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class EdiDispatchAdvicesActionConfigService
  extends EdiMessageBaseActionConfigService
  implements ActionButtonConfigService<EdiDespatchAdvice>
{
  protected getMessageType(): GungEdimessageType {
    return GungEdimessageType.DESPATCH_ADVICE;
  }
}
